import classnames from 'classnames';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import Button from 'shared/components/button/Button';

import styles from './SubmenuItem.module.scss';

const SubmenuItem = ({
  className,
  disabled = false,
  label,
  onClick,
  ...props
}) => (
  <Button
    className={classnames(styles.submenuItem, className)}
    disabled={disabled}
    onClick={onClick ?? noop}
    {...props}
  >
    {label}
  </Button>
);

SubmenuItem.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

export default SubmenuItem;
